import type { ReactNode } from "react";
import { Icons } from "@/components/Icons";

export function EmptyState({
  icon = "Info",
  title,
  body,
  action,
}: {
  icon?: keyof typeof Icons;
  title: string;
  body?: string;
  /** Optional call-to-action rendered below the body copy (e.g. a button). */
  action?: ReactNode;
}) {
  const I = Icons[icon];
  return (
    <div className="empty">
      <div className="glyph"><I size={28} /></div>
      <h4 style={{ fontSize: 15, fontFamily: "var(--font-display)" }}>{title}</h4>
      {body && (
        <p className="muted" style={{ maxWidth: 320, fontSize: 13 }}>{body}</p>
      )}
      {action && (
        <div style={{ marginTop: 12 }}>{action}</div>
      )}
    </div>
  );
}

export default EmptyState;
